<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<h5 style="color:#9b7544"><p>Select Notification Type</p></h5>
<div class="row">
  <div class="col-4" text-center>
    <label style="font-weight:normal">
      <input  type="checkbox" name="email" [value] = "email"  (change)="checkEmail($event,email)">
        Email
      </label>
  </div>
  <div class="col-4" text-center>
    <label style="font-weight:normal">
      <input  type="checkbox" name="sms" [value] = "sms"  (change)="checkSms($event,sms)">
        Sms
      </label>
  </div>
  <div class="col-4" text-center>
    <label style="font-weight:normal">
      <input  type="checkbox" name="pushmessage" [value] = "pushmessage"  (change)="checkPushSms($event,pushmessage)">
        Push message
      </label>
  </div>
</div>
<p>Enter Message Here</p>
<div class="row">
  <textarea rows="8" cols="200" [(ngModel)]="message">
   
  </textarea>
</div>
<div class="row" style="margin-top:10px">
  <div class="col-8" text-center>
    <button class="btn btn-success" (click)="sendrequest()">Send request</button>
  </div>
  <div class="col-4" text-center>
    <button class="btn btn-danger" (click)="Goback()">Cancel</button>
  </div>
</div>
